<script setup lang="ts">
import { onMounted } from "vue";
onMounted(() => {
  console.log("页面加载完成");
});

function getHashQuery(name: string): string | null {
  const hash = window.location.hash;
  const query = hash.includes("?") ? hash.split("?")[1] : "";
  return new URLSearchParams(query).get(name);
}

const setLocal = () => {
  const token = getHashQuery("token");
  const isFtCloudToken = getHashQuery("isFtCloudToken");
  if (token) {
    localStorage.setItem("token", token);
    localStorage.setItem("isFtCloudToken", isFtCloudToken);
  }
};

setLocal();
</script>

<template>
  <router-view />
</template>

<style></style>
